"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GuidesCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactBootstrap = require("react-bootstrap");
var _indexModule = _interopRequireDefault(require("./index.module.css"));
var _component = require("@loadable/component");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Img = (0, _component.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require('../Img'))));
const GuidesCard = _ref => {
  let {
    hyperlinkParams,
    routePath,
    clickHandler,
    // overlayPresent,
    guidesPage,
    imageUrl,
    imageAltText,
    cardTitle,
    cardText,
    buttonArray
  } = _ref;
  const Content = () => /*#__PURE__*/_react.default.createElement("div", {
    className: guidesPage ? _indexModule.default.resourceCards_fromGuides : _indexModule.default.resourceCards
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '15px 30px'
    }
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement(Img, null, /*#__PURE__*/_react.default.createElement("img", {
    className: `${guidesPage ? _indexModule.default.imageTagClass__fromGuides : _indexModule.default.imageTagClass}`,
    src: imageUrl,
    alt: imageAltText
  })))), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      marginBottom: '0.5rem',
      color: 'grey'
    }
  }, cardTitle), cardText && /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.cardText
  }, cardText), buttonArray.map((btn, i) => btn.buttonLink ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    key: i,
    variant: "outline-secondary",
    className: _indexModule.default.resourceCards_Button,
    href: btn.buttonLink,
    target: "_blank"
  }, btn.buttonText) : /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    key: i,
    variant: "outline-secondary",
    className: _indexModule.default.resourceCards_Button
  }, btn.buttonText)));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hyperlinkParams && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 12,
    md: 6,
    lg: 4,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement("a", {
    style: {
      color: 'black',
      textDecoration: 'none'
    },
    href: hyperlinkParams[0],
    target: hyperlinkParams[1],
    rel: hyperlinkParams[2]
  }, /*#__PURE__*/_react.default.createElement(Content, null))), routePath && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 12,
    md: 6,
    lg: 4,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    style: {
      color: 'black',
      textDecoration: 'none'
    },
    to: routePath,
    target: guidesPage ? '_blank' : '_self'
  }, /*#__PURE__*/_react.default.createElement(Content, null))), clickHandler && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 12,
    md: 6,
    lg: 4,
    sm: 6,
    onClick: clickHandler
  }, /*#__PURE__*/_react.default.createElement(Content, null)));
};
exports.GuidesCard = GuidesCard;
var _default = exports.default = GuidesCard;